import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const trackingId = 'G-5V1BG231PK';

ReactGA.initialize(trackingId);

const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Read consent inside the effect — browser API calls belong in effects, not render
    const consentGiven = localStorage.getItem('gaConsent') === 'true';
    if (consentGiven) {
      ReactGA.initialize(trackingId);
      ReactGA.send({
        hitType: 'pageview',
        page: location.pathname + location.search,
      });
    }
  }, [location]);

  const trackModalView = (modalName: string | undefined) => {
    ReactGA.event({
      category: 'Modal',
      action: 'Open',
      label: modalName,
    });
  };

  return { trackModalView };
};

export default useAnalytics;
